import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const PregnancyDiagnosticIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M18.71,19.56a2,2,0,0,1-2.83,0L14,17.69a1.15,1.15,0,0,1,1.62-1.62l1.65,1.64,4.09-4.09A1.16,1.16,0,0,1,23,15.26Zm0-9.25a2,2,0,0,1-2.83,0L14,8.43a1.15,1.15,0,1,1,1.62-1.62l1.65,1.65,4.09-4.09A1.16,1.16,0,0,1,23,6ZM1.82,18.67a1.16,1.16,0,1,1,0-2.31h8.1a1.16,1.16,0,1,1,0,2.31Zm0-9.26a1.16,1.16,0,1,1,0-2.31h8.1a1.16,1.16,0,1,1,0,2.31Z" />
    </SvgIcon>
  )
}
export default PregnancyDiagnosticIcon
